import { UserOutlined } from "@ant-design/icons";
import styles from "./styles.module.scss";

import { Avatar, Divider, Space, Table, Tag, Tooltip } from "antd";
import {
  CPUIcon,
  Error,
  LicenseKey,
  MinusIcon,
  MinusWhiteIcon,
  MobileIcon,
  PlusIcon,
  PlusWhiteIcon,
  ReloadIcon,
  StudioPlatformIcon,
  Tick,
  ViewDetailsIcon,
  WebPlatformIcon,
} from "icons";
import { LicenseInfoTag } from "./license-info-tag";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";
import { getDatatableWidth } from "pages/history/listing/helpers";
import { AssignmentTable } from "./assignmentTable";

export const CreateNewLicense = () => {
  const [studioFinalData, setStudioFinalData] = useState([]);
  const {
    data: studiosOverview,
    isLoading: studiosOverviewLoading,
    error: studiosOverviewError,
  } = UseApiCallForOldDashboardData({
    url: "internal/get/allStudioLicenses",
    method: "POST",
    body: {
      email: "raja.faizan@fenrispakistan.com",
      // email: user?.email,
    },
  });
  const totalData = studiosOverview?.map((item, index) => {
    return {
      key: index + 1,
      username: `${item?.firstName} ${item?.lastName}`,
      systemName: item?.studioID,
      emailAddress: item?.email,
      lastCaptured: item?.lastCapture,
      lastSession: item?.lastSession,
      subscriptionStatus: item?.isActive ? "Active" : "Expired",
      lastCommunicated: "",
      remoteAccess: "",
    };
  });

  const arrayOfTags = [
    {
      label: "Status",
      key: "In Active",
    },
    {
      label: "Creation Date",
      key: "25 July 2025",
    },
    {
      label: "Start Date",
      key: "25 July 2025",
    },
    {
      label: "End Date",
      key: "24 July 2026",
    },
  ];
  const columns = [
    {
      title: "Id",
      dataIndex: "key",
      key: "key",
      // render: (text, record, index) => {
      //   const globalIndex = ((currentPage || 1) - 1) * pageSize + index + 1;
      //   return index < 9 && currentPage === 1 ? `0${index + 1}` : globalIndex;
      //   // const globalIndex = ((currentPage || 1) - 1) * pageSize + index + 1;
      //   // return index < 9 && currentPage === 1 ? `0${index + 1}` : globalIndex;
      // },
      width: "3%",
      fixed: "left",
    },
    {
      title: "First Name",
      dataIndex: "username",
      key: "username",
      width: "12%",
      render: (text) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            flexShrink: "0",
          }}
        >
          <Avatar
            src="https://avatar.iran.liara.run/public/68"
            style={{ flexShrink: "0" }}
          ></Avatar>
          <span style={{ overflow: "hidden" }}>{text}</span>
        </div>
      ),
    },
    {
      title: "Last Name",
      dataIndex: "systemName",
      key: "systemName",
      width: "12%",
      ellipsis: true,
      render: (text) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <CPUIcon />
          <Tooltip title={text}>
            <span
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {text}
            </span>
          </Tooltip>
        </div>
      ),
    },
    {
      title: "Email Address",
      dataIndex: "emailAddress",
      key: "emailAddress",
      width: "14%",
      ellipsis: true,
    },

    {
      title: "Action",
      key: "action",
      width: "10%",
      render: (_, record) => (
        <Space size="middle">
          <button className={styles.viewDetailsBtn}>
            <span>
              <ViewDetailsIcon />
            </span>{" "}
            View Details
          </button>
        </Space>
      ),
    },
  ];
  useEffect(() => {
    setStudioFinalData(totalData);
  }, [studiosOverview]);
  const data = [
    {
      key: "1",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",

      remoteAccess: 9876452,
    },
    {
      key: "2",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",

      remoteAccess: "Add AnyDesk",
    },
    {
      key: "3",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",

      remoteAccess: 9876452,
    },
    {
      key: "4",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",

      remoteAccess: 9876452,
    },
    {
      key: "5",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",

      remoteAccess: 9876452,
    },
    {
      key: "6",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",

      remoteAccess: "Add AnyDesk",
    },
    {
      key: "7",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Expired",
      lastCommunicated: "03.03.25",
      remoteAccess: "Add AnyDesk",
    },
    {
      key: "8",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Expired",
      lastCommunicated: "03.03.25",
      remoteAccess: 9876452,
    },
    {
      key: "9",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",

      remoteAccess: 9876452,
    },
    {
      key: "10",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",

      remoteAccess: 9876452,
    },
    {
      key: "11",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",

      remoteAccess: 9876452,
    },
    {
      key: "12",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",

      remoteAccess: 9876452,
    },
    {
      key: "13",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",

      remoteAccess: 9876452,
    },
  ];
  const platformsIcons = [
    {
      key: "studio",
      icon: StudioPlatformIcon,
    },
    {
      key: "web",
      icon: WebPlatformIcon,
    },
    {
      key: "mobile",
      icon: MobileIcon,
    },
  ];

  return (
    <>
      <Divider />
      <div className={styles.createLicenseContainer}>
        <div className={styles.managerAndKey}>
          <div className={styles.manager}>
            <div className={styles.label}>License Manager:</div>
            <div className={styles.image}>
              <Avatar
                size={75}
                // src={imageBlobUrl}
                alt=""
                icon={<UserOutlined />}
              />
            </div>
            <div className={styles.nameAndEmail}>
              <div className={styles.name}>Michael Smith</div>

              <div className={styles.email}>and.ael@gmail.com</div>
            </div>
          </div>
          <div className={styles.licenseInfo}>
            <LicenseKey />
            <div className={styles.license}>
              <div className={styles.label}>License Key</div>
              <div className={styles.key}>
                <div>BADA-D3E6-B583-C9C2</div>
                <ReloadIcon />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.tags}>
          {arrayOfTags.map((data) => (
            <LicenseInfoTag data={data} />
          ))}
        </div>
        <div className={styles.associatedLicense}>
          <div>
            <div className={styles.title}>PLatforms</div>
            <div className={styles.platformsIcons}>
              {platformsIcons.map((item) => (
                <item.icon key={item.key} />
              ))}
            </div>
          </div>
          <div className={styles.manageAssociation}>
            <div className={styles.label}>Associated Coach License:</div>
            <div
              className={styles.plusMinus}
              style={{ backgroundColor: "#E04646" }}
            >
              <MinusWhiteIcon />
            </div>
            <div className={styles.value}>10</div>
            <div
              className={styles.plusMinus}
              style={{ backgroundColor: "#8ACE42" }}
            >
              <PlusWhiteIcon />
            </div>
          </div>
        </div>
        <AssignmentTable />
      </div>
    </>
  );
};
